import { render, staticRenderFns } from "./FinishScreen.vue?vue&type=template&id=5df293c7&scoped=true&"
import script from "./FinishScreen.vue?vue&type=script&lang=js&"
export * from "./FinishScreen.vue?vue&type=script&lang=js&"
import style0 from "./FinishScreen.vue?vue&type=style&index=0&id=5df293c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df293c7",
  null
  
)

export default component.exports